<app-menu [menu]="menu" itemClass="adn-party-menu-item" activeItemClass="adn-party-menu-item-active"></app-menu>